import React from 'react';
import { Button } from '@mui/material';

const RoleTab = ({
  display_name = '',
  onClick = () => {},
  selected = false,
}) => {
  return (
    <Button
      variant='outlined'
      sx={{
        color: selected ? '#F49D3F' : 'black',
        borderColor: selected ? '#F49D3F' : 'black',
      }}
      onClick={onClick}
    >
      {display_name}
    </Button>
  );
};

export default RoleTab;
// can be removed if not required anywhere else